import{jsxs as e,jsx as n}from"react/jsx-runtime";import{useState as t,useRef as r,useEffect as i}from"react";import{styled as l}from"styled-components";import{BaseLegend as o}from"../Legend/BaseLegend.mjs";const s=l.fieldset`
  background-color: #ffffff;
  padding: 0px;
  border: 0px;
  border-bottom: 1px dotted #999;
  border-radius: 2px;
  margin: 2px 4px 4px 4px;
`,p=l(o)`
  cursor: pointer;
  height: 1.3em;
`,d=l.span`
  float: left;
`,a=l(d)`
  width: 18px;
  height: 15px;
  margin-right: 4px;
  float: left;
  background: url(images/toggle_${({$isOpen:e})=>e?"close":"open"}.png);
`,c=l(d)`
  display: ${({$isOpen:e})=>e?"None":"block"};
  font-size: 11px;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  width: 545px;
  padding-left: 8px;
  margin-left: 4px;
  text-overflow: ellipsis;
`,h=l.div`
  transition: height 0.4s ease;
  overflow: hidden;
`;function u({summary:l,title:o,children:u,onOpen:f,onClose:m,isOpen:g,setIsOpen:x}){var w,y;const[b,v]=t(!1),$=r(null),O=r(null),N=null!=g?g:b,k=null!=x?x:v;i((()=>{N?null==f||f():null==m||m()}),[]);return e(s,{className:"tree",children:[e(p,{className:"tree-head",onClick:async()=>{if(O.current&&$.current){if(N){null==m||m(),O.current.style.height=`${$.current.clientHeight}px`;const e=async()=>new Promise((e=>setTimeout((()=>{e(null)}),0)));await e()}else null==f||f();k(!N)}},children:[n(a,{$isOpen:N}),n(d,{children:o}),n(c,{$isOpen:N,children:l})]}),n(h,{ref:O,className:"tree-body",style:{height:`${N&&null!==(y=null===(w=$.current)||void 0===w?void 0:w.clientHeight)&&void 0!==y?y:0}px`},onTransitionEnd:()=>{O.current&&N&&(O.current.style.height="auto")},children:n("div",{className:"body-content",ref:$,children:u})})]})}export{u as Accordion};
